// 声浪观察 · 编辑部内容数据（静态展示）

export interface NavAnchor {
  id: string;
  label: string;
}

export const siteName = "声浪观察";

export const navAnchors: NavAnchor[] = [
  { id: "focus", label: "焦点档案" },
  { id: "timeline", label: "攻防时间线" },
  { id: "tactics", label: "手法拆解" },
  { id: "reading", label: "深度解读" },
  { id: "playbook", label: "公关手册" },
  { id: "faq", label: "常见问答" },
  { id: "about", label: "关于我们" },
];

export const heroStats = [
  { value: "72h", label: "黄金回应窗口" },
  { value: "6 类", label: "常规模板手法" },
  { value: "3 轮", label: "典型攻防波次" },
  { value: "24/7", label: "舆情值班跟踪" },
];

export interface ArticleCard {
  id: string;
  category: string;
  kind: string;
  title: string;
  standfirst: string;
  summary: string;
  author: string;
  role: string;
  date: string;
  readTime: string;
  tag: string;
  image: string;
  alt: string;
}

export const categoryOptions = [
  { key: "all", label: "全部" },
  { key: "反转", label: "辟谣反转" },
  { key: "律师函", label: "律师函与删帖" },
  { key: "控评", label: "水军与控评" },
  { key: "复盘", label: "危机复盘" },
  { key: "行业", label: "行业观察" },
];

export const articles: ArticleCard[] = [
  {
    id: "huangjin-4h",
    category: "反转",
    kind: "头条 · 策略解析",
    title: "从\u201c沉默是金\u201d到\u201c黄金四小时\u201d：回应窗口为何被一再压缩",
    standfirst: "同一件事，回应早两小时和晚两天，结局可能完全不同。",
    summary:
      "我们复盘近年多个热点事件，发现回应节奏正在被外部倒逼：截图传播速度、大V二创、平台热搜机制共同把回应窗口压缩到以小时计。文章梳理窗口期变化的三大推力，并给出证据链前置、口径分级与发言人授权的建议。",
    author: "编辑部",
    role: "策略组",
    date: "09-06",
    readTime: "9 分钟",
    tag: "窗口期",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20noir%20still%20life%20of%20an%20old%20style%20wired%20desk%20telephone%20and%20scattered%20newspaper%20clippings%20under%20dramatic%20amber%20spotlight%2C%20crimson%20and%20golden%20tones%20against%20dark%20charcoal%20background%2C%20cinematic%20chiaroscuro%20lighting%2C%20film%20grain%2C%20premium%20magazine%20aesthetic&width=1200&height=760&seq=sl-article-01&orientation=landscape",
    alt: "老式桌面电话与报纸剪报的暗调编辑部静物",
  },
  {
    id: "falv-hanliang",
    category: "律师函",
    kind: "法律向",
    title: "一纸律师函的法律含量：声明不等于起诉，背后是证据链的角力",
    standfirst: "律师函发得越凶，往往越说明诉讼未必会来。",
    summary:
      "律师函本质是私力救济与诉前声明，威慑力来自潜在诉讼而非函件本身。我们拆解一封函件要成立所需的证据留痕、管辖与送达，也说明\u201c不诉而函\u201d为何常被视为姿态大于事实，帮助读者建立辨别坐标系。",
    author: "法务观察员",
    role: "特约作者",
    date: "09-04",
    readTime: "8 分钟",
    tag: "证据链",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20a%20folded%20legal%20document%20with%20red%20wax%20seal%20and%20brass%20scales%20on%20dark%20wood%20desk%2C%20warm%20candlelight%20glow%2C%20crimson%20and%20golden%20palette%2C%20cinematic%20shadows%2C%20film%20grain%2C%20premium%20magazine%20aesthetic&width=1200&height=760&seq=sl-article-02&orientation=landscape",
    alt: "红色火漆印章与天平的法律文件暗调静物",
  },
  {
    id: "kongping-gongyechang",
    category: "控评",
    kind: "机制观察",
    title: "评论区战场：控评、铺量与\u201c路人缘\u201d的工业化运营",
    standfirst: "你看到的\u201c多数人的声音\u201d，可能只是一条排好的流水线。",
    summary:
      "从号池轮换到话术母本，从时间曲线到点赞权重，我们还原控评作业的常见工序，并分析平台反作弊如何让\u201c铺量\u201d成本不断抬升。也讨论普通读者如何识别明显的机器痕迹与情绪带节奏。",
    author: "编辑部",
    role: "机制组",
    date: "09-02",
    readTime: "10 分钟",
    tag: "评论区",
    image:
      "https://readdy.ai/api/search-image?query=dark%20editorial%20concept%20of%20multiple%20glowing%20smartphone%20screens%20reflecting%20comment%20bubbles%20in%20red%20and%20amber%20light%20on%20a%20dark%20surface%2C%20mysterious%20cinematic%20mood%2C%20film%20grain%2C%20premium%20magazine%20photography&width=1200&height=760&seq=sl-article-03&orientation=landscape",
    alt: "多块屏幕反射评论气泡的暗调概念图",
  },
  {
    id: "ci-sheng-yuqing",
    category: "复盘",
    kind: "复盘精读",
    title: "一次未遂危机为何被二次引爆：复盘\u201c次生舆情\u201d的连锁逻辑",
    standfirst: "真正的危机，往往出现在澄清声明发布之后。",
    summary:
      "错别字、翻旧账、口径打架、拉踩同僚……每一次补刀都可能是新的热搜。我们以一个虚拟事件的全程复盘，展示次生舆情的传染路径，指出为何\u201c回应得越多、翻车越深\u201d往往源于内部信息孤岛。",
    author: "编辑部",
    role: "复盘组",
    date: "08-30",
    readTime: "11 分钟",
    tag: "次生舆情",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20image%20of%20a%20burning%20match%20igniting%20a%20chain%20of%20small%20paper%20strips%20in%20midair%2C%20warm%20ember%20orange%20and%20crimson%20glow%20against%20black%2C%20dramatic%20close%20up%2C%20film%20grain%2C%20premium%20magazine%20aesthetic&width=1200&height=760&seq=sl-article-04&orientation=landscape",
    alt: "火柴点燃纸链蔓延的暗调概念图",
  },
  {
    id: "fanzhuan-juben",
    category: "反转",
    kind: "现象学",
    title: "反转剧本学：当\u201c澄清\u201d本身成为新的流量事件",
    standfirst: "锤与反锤之间，吃瓜群众的注意力才是真正的主角。",
    summary:
      "反转不是终点而是新的起点。我们观察\u201c小作文—实锤—反转—再反转\u201d的循环结构，分析情绪先行的传播机制，以及为何双方都在争夺\u201c首发定义权\u201d与\u201c最后一锤\u201d的位置。",
    author: "观察员 · 阿诚",
    role: "特约作者",
    date: "08-27",
    readTime: "7 分钟",
    tag: "反转",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20concept%20of%20two%20sides%20of%20a%20mirror%20turning%2C%20one%20side%20crimson%20the%20other%20amber%2C%20on%20a%20dark%20stage%2C%20theatrical%20spotlight%2C%20cinematic%20mood%2C%20film%20grain%2C%20premium%20magazine%20photography&width=1200&height=760&seq=sl-article-05&orientation=landscape",
    alt: "红与金两面相对旋转镜面的舞台概念图",
  },
  {
    id: "gongguang-shijian",
    category: "行业",
    kind: "幕后专访",
    title: "公关公司眼中的危机：我们如何做舆情分级与预案推演",
    standfirst: "好的危机处理，早在危机发生前就已经开始。",
    summary:
      "我们与几位从业者聊了聊：从舆情雷达的搭建、红黄绿分级，到每年两次的桌面推演，再到\u201c不回应也是一种策略\u201d的取舍。你看到的是临场发挥，背后往往是数月准备。",
    author: "编辑部",
    role: "专访组",
    date: "08-24",
    readTime: "12 分钟",
    tag: "预案",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20a%20war%20room%20whiteboard%20with%20red%20timeline%20markers%20and%20polaroid%20photos%20under%20a%20desk%20lamp%2C%20warm%20amber%20and%20charcoal%20tones%2C%20cinematic%20mood%2C%20film%20grain%2C%20premium%20magazine%20aesthetic&width=1200&height=760&seq=sl-article-06&orientation=landscape",
    alt: "作战室白板与拍立得照片的编辑部静物",
  },
  {
    id: "reng-shuili",
    category: "控评",
    kind: "数据观察",
    title: "数据水位的泡沫：热搜、脱水与榜单经济学",
    standfirst: "有些\u201c爆\u201d是买来的，有些\u201c糊\u201d是压出来的。",
    summary:
      "热搜背后的报价体系、脱水数据的清洗逻辑、榜单排名的注水与反注水……我们用公开信息与从业者口径，拼出一张平台热度经济的地图，并提示读者哪些指标更有参考价值。",
    author: "观察员 · 林晚",
    role: "特约作者",
    date: "08-21",
    readTime: "9 分钟",
    tag: "热搜",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20of%20floating%20glass%20cubes%20of%20varied%20sizes%20glowing%20amber%20and%20red%20over%20a%20dark%20void%2C%20like%20ascending%20data%20columns%2C%20film%20grain%2C%20premium%20magazine%20aesthetic&width=1200&height=760&seq=sl-article-07&orientation=landscape",
    alt: "红色与金色悬浮立方体上升的数据概念图",
  },
  {
    id: "shan-tie-jilu",
    category: "律师函",
    kind: "机制拆解",
    title: "删帖记录不是\u201c洗白证据\u201d，而是危机管理的资产负债表",
    standfirst: "每一次删除都是一次决策：保形象，还是留把柄。",
    summary:
      "我们梳理常见删帖诉求的类型化理由——名誉、隐私、竞品抹黑、误导信息——并讨论平台申诉与司法渠道的边界。删帖记录本身常常成为二次报道的素材，处理需格外审慎。",
    author: "编辑部",
    role: "合规组",
    date: "08-18",
    readTime: "8 分钟",
    tag: "删帖",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20a%20black%20wastebasket%20holding%20crumpled%20paper%20sheets%20with%20faint%20red%20text%20under%20a%20harsh%20amber%20lamp%2C%20dark%20charcoal%20background%2C%20cinematic%20chiaroscuro%2C%20film%20grain%2C%20premium%20magazine%20aesthetic&width=1200&height=760&seq=sl-article-08&orientation=landscape",
    alt: "废纸篓内揉皱纸页的编辑部暗调静物",
  },
  {
    id: "zhengju-qingxu",
    category: "复盘",
    kind: "决策模拟",
    title: "证据型回应与情绪型回应：两条路线的代价测算",
    standfirst: "摆事实、讲道理，有时竟比一句体面的致歉更伤口碑。",
    summary:
      "受众要的是\u201c有说服力的故事\u201d，而不仅是\u201c没有漏洞的事实\u201d。我们用两个对照框架，测算\u201c先安抚再举证\u201d与\u201c直接硬刚\u201d在不同舆论底色下的得与失，供读者自行推演。",
    author: "编辑部",
    role: "策略组",
    date: "08-15",
    readTime: "10 分钟",
    tag: "决策",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20of%20two%20chess%20figures%20one%20crimson%20one%20ivory%20standing%20on%20a%20checkerboard%20with%20warm%20spotlight%20across%20a%20dark%20board%2C%20dramatic%20shadows%2C%20film%20grain%2C%20premium%20magazine%20aesthetic&width=1200&height=760&seq=sl-article-09&orientation=landscape",
    alt: "红色与象牙白棋子立于棋盘的概念图",
  },
];

export const featuredArticle = articles[0];

export const focusArticles = [articles[1], articles[2], articles[3]];

export const relatedLinks = articles.slice(4, 9);

export interface TimelineStep {
  phase: string;
  index: string;
  title: string;
  desc: string;
  point: string;
}

export const timelineSteps: TimelineStep[] = [
  {
    phase: "发酵期",
    index: "01",
    title: "情报汇总与评估",
    desc: "第一时间建立事实底座：区分实锤、传闻与断章取义，梳理信源关系图，判定事件的真实性等级与扩散速度。",
    point: "口径的分歧往往源于事实尚未统一",
  },
  {
    phase: "研判期",
    index: "02",
    title: "舆情分级与会诊",
    desc: "按传播规模、伤害程度与是否涉法分为红黄绿三档，对应不同响应层级；同时预演最坏情形，确定止损边界。",
    point: "分级决定节奏，预案决定胆量",
  },
  {
    phase: "决策期",
    index: "03",
    title: "回应策略定调",
    desc: "在\u201c硬刚、澄清、道歉、冷处理\u201d四条主路中取舍，并由授权人签发，确保对外只保留一个声音。",
    point: "最危险的是临阵各自表态",
  },
  {
    phase: "执行期",
    index: "04",
    title: "发布与口径统一",
    desc: "选择时段与平台首发，正文与评论区同时进入受控状态，避免声明与后续动作互相打架。",
    point: "声明是承诺，后续都要兑现",
  },
  {
    phase: "对抗期",
    index: "05",
    title: "证据呈现与攻防",
    desc: "以时间线、原始记录、第三方佐证构筑证据链；必要时通过律师函与法律途径回应不实内容。",
    point: "每一句话都要经得起二次剪辑",
  },
  {
    phase: "修复期",
    index: "06",
    title: "控评与舆论引导",
    desc: "在真实与克制之间调配：纠正明显误导、引导理性讨论，但不过度铺量以免引发新一轮反弹。",
    point: "控的是偏离，不是所有反对",
  },
  {
    phase: "复盘期",
    index: "07",
    title: "复盘与机制补全",
    desc: "危机结束后回到案头：哪些预案失效、哪些话术踩雷，沉淀成下一轮更抗打的舆情体系。",
    point: "最好的公关，是让下一次更稳",
  },
];

export interface Tactic {
  index: string;
  title: string;
  en: string;
  desc: string;
  detail: string;
  signal: string;
  image: string;
  alt: string;
}

export const tactics: Tactic[] = [
  {
    index: "A",
    title: "辟谣与反转",
    en: "REVERSAL",
    desc: "以时间线、原文件、第三方佐证构建证据，推翻\u201c不实指控\u201d的叙事框架。",
    detail:
      "常见的操作是拆解对方逻辑漏洞、补齐上下文、放出关键节点证据，把\u201c被指控者\u201d重新叙事为\u201c被冤枉者\u201d。成功的反转依赖证据强度与受众情绪的双重管理。",
    signal: "观察是否有原始时间戳、全量记录而非截取片段",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20concept%20of%20a%20magnifying%20glass%20over%20printed%20timeline%20documents%20under%20crimson%20and%20amber%20light%2C%20dark%20charcoal%20background%2C%20cinematic%20chiaroscuro%2C%20film%20grain%2C%20premium%20magazine%20photography&width=1000&height=720&seq=sl-tactic-A&orientation=portrait",
    alt: "放大镜查看时间线文件的概念图",
  },
  {
    index: "B",
    title: "律师函声明",
    en: "LEGAL NOTE",
    desc: "以公函姿态向发布方与平台施压，宣示\u201c将追责到底\u201d的法律立场。",
    detail:
      "函件的威慑力来自背后的诉讼可能。用途在于定调、止损与向合作方传递信心。真正有价值的是函后是否立案、是否进入司法程序，而非函件措辞的激烈程度。",
    signal: "区分\u201c已委托律师取证\u201d与\u201c已向法院起诉\u201d的措辞差异",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20a%20black%20legal%20pen%20and%20a%20sealed%20letter%20with%20red%20stamp%20on%20dark%20leather%20desk%2C%20warm%20amber%20candlelight%2C%20cinematic%20shadows%2C%20film%20grain%2C%20premium%20magazine%20aesthetic&width=1000&height=720&seq=sl-tactic-B&orientation=portrait",
    alt: "黑色钢笔与火漆信封的编辑部静物",
  },
  {
    index: "C",
    title: "删帖与压热搜",
    en: "TAKEDOWN",
    desc: "基于名誉、隐私与误导信息等理由，推动平台处置特定内容的扩散。",
    detail:
      "删帖是危机管理的一张牌，却也是双刃剑：处理得越干净，越容易被解读为\u201c心虚\u201d，进而成为新的报道线索。有效与否取决于理由正当性与执行透明度。",
    signal: "留意被删帖的\u201c留痕\u201d是否反而助推二次传播",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20of%20a%20hand%20reaching%20to%20erase%20glowing%20red%20chalk%20marks%20from%20a%20dark%20slate%2C%20amber%20backlight%2C%20mysterious%20mood%2C%20film%20grain%2C%20premium%20magazine%20photography&width=1000&height=720&seq=sl-tactic-C&orientation=portrait",
    alt: "手在暗色石板上擦去红色记号的概念图",
  },
  {
    index: "D",
    title: "水军与控评",
    en: "ASTROTURFING",
    desc: "通过账号矩阵与情绪话术营造\u201c主流观点\u201d，稀释不利声音。",
    detail:
      "从铺量、刷屏到顶帖与踩评，水军运作追求的是让某个结论看起来像\u201c自发共识\u201d。识别关键在于内容的机械感、账号的轨迹异常与情感浓度的失真。",
    signal: "关注高赞评论的账号注册时间与发言历史是否高度同质",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20concept%20of%20silhouettes%20of%20many%20identical%20phone%20users%20typing%20in%20the%20dark%20lit%20by%20red%20and%20amber%20screens%2C%20faceless%20crowd%20mood%2C%20cinematic%2C%20film%20grain%2C%20premium%20magazine%20aesthetic&width=1000&height=720&seq=sl-tactic-D&orientation=portrait",
    alt: "众多一致剪影在红光中打字的暗调概念图",
  },
];

export interface PlaybookItem {
  title: string;
  desc: string;
}

export const playbookDo: PlaybookItem[] = [
  { title: "先定事实，再定口径", desc: "没有统一事实的回应，会在每一次细节追问中露出破绽。" },
  { title: "把最坏情形预演一遍", desc: "危机前做过桌面推演的一方，临场往往更从容。" },
  { title: "给声明留出兑现空间", desc: "承诺的每一项处置，都应能给出后续闭环。" },
  { title: "区分误导与反对", desc: "纠正明显的错误信息，但别把正常质疑都当成敌人。" },
];

export const playbookDont: PlaybookItem[] = [
  { title: "别让多个声音抢麦", desc: "内部口径不一，是许多反转翻车的第一因。" },
  { title: "别把声明当免责金牌", desc: "函件与澄清只是手段，受众看的是最终处理结果。" },
  { title: "别在情绪峰值硬碰硬", desc: "当舆论处于情绪高点，讲理往往被误读为傲慢。" },
  { title: "别为删帖而删帖", desc: "每一次高调删除，都可能成为被追着打的把柄。" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "明星声明与律师函到底有多大法律效力？",
    a: "声明是单方表态，不直接产生法律后果；律师函是正式的函告与威慑，其力度取决于函后是否真的进入诉讼程序。把\u201c函\u201d当\u201c判\u201d看，容易高估其分量。",
  },
  {
    q: "删帖记录为什么反而可能引爆危机？",
    a: "公开可见的处理痕迹会被解读为心虚或掩盖。若理由不够正当、方式又高调，删除行为本身就会变成新的新闻点，形成所谓的\u201c次生舆情\u201d。",
  },
  {
    q: "如何判断评论区是否存在水军或控评？",
    a: "可留意高赞账号的注册时间、发言轨迹是否同质，评论话术是否高度模板化，情感是否失真且集中。但没有绝对标准，需结合证据综合判断。",
  },
  {
    q: "辟谣反转是不是总能扭转口碑？",
    a: "不一定。反转依赖证据强度、传播时点与受众既有情绪。即便证据成立，若第一印象已成、情绪持续高位，澄清也可能被解读为\u201c公关话术\u201d。",
  },
  {
    q: "公众应该如何理性看待这类公关博弈？",
    a: "建议关注\u201c证据与结果\u201d而非\u201c话术与姿态\u201d：等双方都出证据、让子弹多飞一会儿，并留意官方渠道与司法进展，避免被单方面叙事带节奏。",
  },
  {
    q: "声浪观察的内容是否针对具体真人明星？",
    a: "本站定位为娱乐舆论与危机公关的行业观察与方法论内容。为规避失实风险，案例均以中性化、概括化方式呈现，不针对真实个体作事实性断言或负面定性。",
  },
];

export interface VoiceItem {
  name: string;
  role: string;
  text: string;
}

export const voices: VoiceItem[] = [
  {
    name: "一档看得清套路的媒体",
    role: "读者 · 品牌公关从业者",
    text: "把舆论场的潜规则讲得既有结构又不失分寸，值得放进案头作为日常参考。",
  },
  {
    name: "吃瓜也吃出门道",
    role: "读者 · 新媒体运营",
    text: "以前看热闹，现在能分辨回应背后是姿态还是真动作，变化挺明显。",
  },
  {
    name: "行业外也能读懂的拆解",
    role: "读者 · 传播学研究生",
    text: "把律师函、删帖、控评这些概念讲得很系统，案例虽中性化，逻辑链很完整。",
  },
];